import { Injectable } from "@angular/core";
import { Service } from "src/app/core/jsonapi/service";
import { TemplateContracts } from "../_types/template-contract";

@Injectable({
    providedIn: 'root',
})
export class TemplatesContractsService extends Service<TemplateContracts> {
    public override type = 'templateContracts';
    public override url = 'communications/templateContracts';

}
